import { toast } from 'react-toastify';
import i18n from '../../i18n';
import { setRedirect } from '../actions/rLink.action';
import { settingsInit } from '../actions/settings.action';
import { apiServices } from '../services/api.services';
import Socket from '../sockets';

const socketMiddleware = (store) => {

    const refreshServersAndDevices = () => {
        apiServices.get("/serversdevices").then((res) => {
            if (res && res.data) {
                store.dispatch({type: 'SET_SERVERS', servers: res.data.servers});
                store.dispatch({type: 'SET_DEVICES', devices: res.data.devices});
            }
        }).catch(err => {
            return err;
        });
    }

    const refreshGuilds = () => {
        apiServices.get("/guilds").then((res) => {
            if (res) return store.dispatch({type: 'SET_GUILDS', guilds: res.data});
        }).catch(err => {
            return err;
        });
    }
    const refreshServers = () => {
        apiServices.get("/servers").then((res) => {
            if (res && res.data) {
                store.dispatch({type: 'SET_SERVERS', servers: res.data});
            }
        }).catch(err => {
            return err;
        });
    }
    const refreshDevices = () => {
        store.getState().rLink.bufferRefreshDevice && clearTimeout(store.getState().rLink.bufferRefreshDevice);
        var call  = setTimeout(function() {
            apiServices.get("/devices").then((res) => {
                if (res && res.data) store.dispatch({type: 'SET_DEVICES', devices: res.data});
            });
            store.dispatch({type: 'CLEAR_BUFFER_REFRESH_DEVICE'});
        }, 2000);
        store.dispatch({type: 'SET_BUFFER_REFRESH_DEVICE', buffer: call});
    }
    const refreshDevicesCallback = () => {
        return new Promise((resolve, reject) => {
            store.getState().rLink.bufferRefreshDevice && clearTimeout(store.getState().rLink.bufferRefreshDevice);
            var call  = setTimeout(function() {
                apiServices.get("/devices").then((res) => {
                    if (res && res.data) {
                        store.dispatch({type: 'SET_DEVICES', devices: res.data});
                        resolve();
                    } else reject('refreshDevices: No data found !');
                }).catch(err => reject(err));
                store.dispatch({type: 'CLEAR_BUFFER_REFRESH_DEVICE'});
            }, 2000);
            store.dispatch({type: 'SET_BUFFER_REFRESH_DEVICE', buffer: call});
        });
    }
    const refreshSettings = () => {
        apiServices.get("/settings").then((res) => {
            if (res && res.data) settingsInit(store.dispatch, res.data);
        }).catch(err => {
            return err;
        });
    }
    const defaultModal = {
        switch: {
            title: "MODAL_SWITCH_TITLE",
            description: "MODAL_SWITCH_DESCRIPTION",
            redirect: "switches"
        },
        alarm: {
            title: "MODAL_ALARM_TITLE",
            description: "MODAL_ALARM_DESCRIPTION",
            redirect: "alarms"
        },
        storage: {
            title: "MODAL_STORAGE_TITLE",
            description: "MODAL_STORAGE_DESCRIPTION",
            redirect: "storages"
        }
    };

    const getTypeName = (type) => {
        switch (type) {
            case 1: 
                return "switch";
            case 2:
                return "alarm";
            case 3:
                return "storage";
            default:
                return "switch";
        }
    }
    const checkDevice = (deviceId) => {
        var devices = {...store.getState().devices};
        return new Promise(function (resolve, reject) {
            if (devices.switches.findIndex((d) => d.id === deviceId) > -1) return reject();
            else if (devices.alarms.findIndex((d) => d.id === deviceId) > -1) return reject();
            else if (devices.storages.findIndex((d) => d.id === deviceId) > -1) return reject();
            else return resolve();
        });
    };
    const newDevice = (data) => {
        checkDevice(data.id).then(function() {
            refreshDevicesCallback().then(function() {
                var type = getTypeName(data.type);
                const modal = {
                    title: defaultModal[type].title,
                    description: defaultModal[type].description,
                    type: type,
                    id: data.id,
                    display: true
                };
                store.dispatch({type: 'DEVICES_MODAL_SET', modal});
                setTimeout(setRedirect(`/${defaultModal[type].redirect}`), 200);
            }).catch((err) => console.log('refreshDevices: ', err));
        });
    }

    const socket = new Socket([{
        event: "connect_error",
        func: () => {
            console.log('WS: connection error');
        }
    },{
        event: "refreshServersAndDevices",
        func: refreshServersAndDevices
    },{
        event: "refreshGuilds",
        func: refreshGuilds
    },{
        event: "refreshServers",
        func: refreshServers
    },{
        event: "refreshDevices",
        func: refreshDevices
    },{
        event: "refreshSettings",
        func: refreshSettings
    },{
        event: "newDevice",
        func: newDevice
    },{
        event: "limitExceeded",
        func: (type) => {
            toast.error(`${i18n.t(getTypeName(type))} - ${i18n.t('error.limitExceeded', {ns: 'devices'})}`);
        }
    },{
        event: "newVIP",
        func: (data) => {
            toast.success(`${i18n.t(`added.${data.plan}`, {ns: 'vip'})}`);
            store.dispatch({type: 'UPDATE_VIP', plan: data.plan, remain: data.remain});
        }
    },{
        event: "updateTeam",
        func: (data) => {
            store.dispatch({type: 'UPDATE_TEAM', team: data.team});
        }
    },{
        event: "updateMarkers",
        func: (data) => {
            store.dispatch({type: 'UPDATE_MARKERS', markers: data.markers, vendings: data.vendings});
        }
    }]);
    
    return (next) => (data) => {
        const socketServer = window.location.host === "rustlink.io" ? 'wss://rustlink.io' : `ws://${window.location.host}`;
        if (!data) return;
        switch (data.type) {
            case 'SOCKETS_CONNECT_SOCKET':
                socket.connect(socketServer, data.uid);
                break;
            case 'SOCKETS_SETUP_ACTIVE':
                socket.setActive(data.state);
                break;
            default:
                break;
        }
        return next(data);
    };
};

export default socketMiddleware;
